// extracted by mini-css-extract-plugin
export var addressContainer = "contact-module--address-container--pEvBu";
export var contactContainer = "contact-module--contact-container--tSKVY";
export var contactFormContainer = "contact-module--contact-form-container--vxJtf";
export var contactFormTitle = "contact-module--contact-form-title--t7RLs";